{
  "common": {
    "cancel": "Cancel",
    "login": "Log in",
    "backToLogin": "Go to login",
    "copy": "Copy",
    "copied": "Copied",
    "show": "Show",
    "hide": "Hide",
    "language": "Language",
    "norwegian": "Norwegian",
    "english": "English",
    "selectPlaceholder": "Select …",
    "noOptions": "No matches",
    "createOption": "Add “{{value}}”",
    "somethingWentWrong": "Something went wrong. Please try again or contact your administrator."
  },
  "a11y": {
    "skipToContent": "Skip to main content"
  },
  "nav": {
    "login": "Log in",
    "adLogin": "AD login",
    "logout": "Log out",
    "apiToken": "API token",
    "statistics": "Statistics",
    "users": "Users",
    "role": "Roles",
    "mappings": "Mappings",
    "application": "Applications",
    "registration": "Registration",
    "menu": "Menu",
    "profile": "My profile",
    "help": "Help",
    "toggleNavigation": "Toggle navigation"
  },
  "help": {
    "title": "Help & user guide",
    "intro": "A guide for operators who register and manage users, mappings and access in Dekon SSO. Search, or open a topic to read more.",
    "search": "Search the help …",
    "expandAll": "Expand all",
    "collapseAll": "Collapse all",
    "noResults": "No matches for your search.",
    "note": "Note",
    "warning": "Important",
    "updated": "Last updated"
  },
  "footer": {
    "version": "Version",
    "tagline": "Dekon SSO"
  },
  "theme": {
    "switchToLight": "Switch to light theme",
    "switchToDark": "Switch to dark theme"
  },
  "validation": {
    "required": "This field is required.",
    "email": "Enter a valid email address.",
    "emailWithDomain": "Enter your full username with domain, e.g. name@domain.com",
    "minLength": "The value is too short.",
    "maxLength": "The value is too long.",
    "passwordWeak": "Password must be at least 8 characters with upper- and lowercase letters and a number.",
    "passwordsMustMatch": "The passwords do not match.",
    "digitsOnly": "Digits only.",
    "phone": "Enter a valid phone number.",
    "baseUrl": "Must be http(s)://domain-or-ip with no trailing slash (e.g. http://192.168.168.213:19999).",
    "path": "Must start with a slash, e.g. /smartstore2."
  },
  "login": {
    "title": "Dekon SSO",
    "subtitle": "Log in with your username and password.",
    "adSubtitle": "Log in with your Active Directory account.",
    "username": "Username",
    "usernamePlaceholder": "name@domain.com",
    "password": "Password",
    "passwordPlaceholder": "Your password",
    "submit": "Log in",
    "forgotPassword": "Forgot password?",
    "captchaHint": "Confirm you are not a robot to continue.",
    "error": "Wrong username or password. Please try again.",
    "expired": "Your session has expired. Please log in again."
  },
  "twofa": {
    "title": "Two-factor confirmation",
    "subtitle": "Choose how you want to confirm the login.",
    "authy": "Authy app (recommended)",
    "authyHint": "Open the Authy app on your phone and approve the request.",
    "emailNotRecommended": "Email (not recommended)",
    "appKey": "Authy key",
    "copyKey": "Copy key",
    "rememberDevice": "Remember this device",
    "rememberDeviceHint": "You won't be asked for two-factor on this device for a while.",
    "emailSent": "We've sent a code by email. Enter it below to confirm.",
    "code": "One-time code",
    "codePlaceholder": "6-digit code",
    "verify": "Confirm",
    "resendEmail": "Resend email",
    "attemptsLeft": "{{count}} attempts left before captcha is required.",
    "error": "The confirmation failed. Please try again or choose another method."
  },
  "forgot": {
    "title": "Forgot password?",
    "subtitle": "Enter your email and we'll send you a link to reset your password.",
    "email": "Email address",
    "submit": "Send reset link",
    "success": "We've sent a reset link to your registered email address."
  },
  "setPassword": {
    "resetTitle": "Reset password",
    "resetSubtitle": "Choose a new password.",
    "confirmTitle": "Confirm account",
    "confirmSubtitle": "Set a password to activate your account.",
    "password": "New password",
    "confirmPassword": "Confirm password",
    "submitReset": "Reset password",
    "submitConfirm": "Set password"
  },
  "passwordFeedback": {
    "ok": "Your password has been changed. You can now log in.",
    "badRequest": "Something went wrong changing the password. Please try again.",
    "unauthorized": "You're not authorized to make this change.",
    "userNotFound": "User not found.",
    "default": "Something went wrong changing the password. Please try again."
  },
  "admin": {
    "stats": {
      "title": "Statistics",
      "description": "A quick overview of today's activity, read from telemetry.",
      "activeToday": "Unique active users so far today",
      "activeTodayHint": "Distinct signed-in users seen since midnight (local time) — the same user counts once, even when reusing a session.",
      "mostUsedType": "Most-used application type",
      "mostUsedBadge": "most used",
      "usersAndRequests": "{{users}} users · {{requests}} requests",
      "otherType": "Other",
      "legendApp": "{{requests}} requests ({{pct}} %) · {{users}} users",
      "legendOther": "{{requests}} requests ({{pct}} %) · login, API, static files, etc.",
      "usagePct": "{{pct}} % usage",
      "usageOf": "{{active}} of {{total}} registered users",
      "usersWord": "users",
      "mappingTitle": "Users per application",
      "mappingDesc": "Distribution of mappings across applications (from the database).",
      "withMapping": "Has mapping",
      "withoutMapping": "No mapping",
      "aspAggregate": "ASP – all instances",
      "aspNote": "unique users across {{apps}} ASP instances (combined — overlaps the apps below)",
      "singleApps": "Individual applications",
      "topNote": "Top {{shown}} of {{total}} applications.",
      "hourlyTitle": "Activity today · per hour (local time)",
      "monthlyTitle": "Active users per day · this month",
      "monthlyNote": "Bars (active users) appear from when per-user tracking was enabled. The requests line covers the whole period. Today's bar is lighter because the day is still in progress.",
      "seriesUsers": "Active users",
      "seriesCalls": "Requests",
      "noUsage": "No application usage registered yet today.",
      "updatedAt": "Updated {{time}}",
      "refresh": "Refresh",
      "loading": "Loading statistics …",
      "error": "Could not load the statistics. Please try again.",
      "unavailable": "Statistics are not available in this environment."
    },
    "role": {
      "title": "Roles",
      "description": "Change a user's role among the predefined roles. New roles cannot be added.",
      "user": "User",
      "newRole": "New role",
      "submit": "Update role",
      "success": "The user's role has been updated.",
      "roleExists": "The user already has this role.",
      "loadError": "Could not load data. Try reloading the page.",
      "error": "Something went wrong updating the role."
    },
    "token": {
      "title": "API token",
      "description": "Generate a token for the API user. The token grants API access, so handle and share it securely.",
      "email": "Email",
      "connectionString": "Connection string",
      "generate": "Generate token",
      "tokenLabel": "Generated token",
      "securityNote": "Copy the token now and store it safely – it won't be shown again.",
      "error": "Could not generate token. Please try again."
    },
    "application": {
      "title": "Applications",
      "description": "Register an application. Rarely needed – mostly only for new customers.",
      "sync": "Sync from configuration",
      "syncSuccess": "Applications synced from configuration.",
      "syncNothing": "No new applications to sync.",
      "or": "– or –",
      "type": "Application type",
      "smartstore": "Smartstore",
      "jasper": "Jasper",
      "name": "Application name",
      "namePlaceholder": "Example: Dekon ASP – Lekia Asker – 10034",
      "baseUrl": "Base URL",
      "baseUrlPlaceholder": "Example: http://192.168.168.213:10034",
      "path": "Path",
      "pathPlaceholder": "Example: /smartstore2",
      "register": "Register",
      "added": "The application has been added.",
      "nameExists": "The application name already exists.",
      "error": "Could not add the application.",
      "selectApp": "Select application",
      "typeLabel": "Type",
      "attachedUsers": "{{count}} user(s) attached",
      "update": "Update",
      "updated": "The application was updated.",
      "updateError": "Could not update the application.",
      "delete": "Delete application",
      "deleteTitle": "Delete application",
      "confirmDelete": "Deleting an application can cause serious problems and cannot be undone. Type the application name below to confirm.",
      "confirmLabel": "Type \"{{name}}\" to confirm",
      "proceed": "Delete application",
      "deleted": "The application was deleted.",
      "deleteError": "Could not delete the application.",
      "deleteHasUsers": "Cannot delete: there are users attached to this application. Remove the mappings first.",
      "loadError": "Could not load applications.",
      "mappedUsersTitle": "Attached users",
      "mappedUsersHint": "Select users and remove their mapping to this application. The users keep their accounts.",
      "selectAll": "Select all",
      "noMappedUsers": "No users are attached to this application.",
      "loadUsersError": "Could not load the users.",
      "removeSelected": "Remove selected ({{count}})",
      "removeMappingsTitle": "Remove user mappings",
      "confirmRemoveMappings": "Remove {{count}} user mapping(s) from \"{{name}}\"? The users keep their accounts but lose access to this application.",
      "removeMappingsProceed": "Remove mappings",
      "mappingsRemoved": "{{count}} mapping(s) removed.",
      "removeMappingsError": "Could not remove the mappings."
    }
  },
  "mappings": {
    "title": "Mappings",
    "smartstoreTab": "SmartStore",
    "reportingTab": "Reporting",
    "modeAdd": "Add",
    "modeEdit": "Edit",
    "delete": "Delete mapping",
    "deleteTitle": "Delete mapping",
    "confirmDelete": "Are you sure you want to delete this mapping? This cannot be undone.",
    "proceed": "Delete",
    "deleted": "The mapping was deleted.",
    "deleteError": "Could not delete the mapping.",
    "smartstore": {
      "title": "SmartStore mapping",
      "description": "Add or edit SmartStore mappings for an SSO user. Make sure the information is correct to avoid problems later.",
      "selectUser": "Select user to edit",
      "instance": "SmartStore instance",
      "userName": "Username",
      "userNamePlaceholder": "user@domain.com",
      "user": "SmartStore user (CS10)",
      "userPassword": "Password (CS10)",
      "companyId": "Company (CS00)",
      "companyPassword": "Company password (CS00)",
      "storeId": "Store id/number (BD88)",
      "addJasper": "Add Jasper mapping",
      "jasperServer": "Select Jasper server",
      "register": "Register",
      "update": "Update",
      "registered": "User application registered!",
      "updated": "SmartStore mapping updated!",
      "userNotFound": "User not found.",
      "userExists": "User already exists.",
      "domainInvalid": "The domain is not correct.",
      "mappingExists": "A mapping already exists for this user.",
      "serverError": "Server error. Please try again.",
      "loadError": "Could not load the mapping for the selected user.",
      "updateError": "Could not update the SmartStore mapping."
    },
    "jasper": {
      "title": "Reporting registration",
      "description": "Add Jasper reporting mappings for a user.",
      "instance": "Jasper server instance",
      "user": "Username",
      "orgId": "Jasper organization id",
      "ssoUserName": "SSO username",
      "jasperUser": "Jasper username",
      "password": "Jasper password",
      "register": "Register",
      "update": "Update",
      "added": "The mapping has been added.",
      "updated": "Jasper mapping updated!",
      "mappingExists": "A mapping already exists for this user.",
      "addError": "Could not add the mapping. Please try again.",
      "updateError": "Could not update the Jasper mapping.",
      "loadError": "Could not load the Jasper mapping for the selected user.",
      "instanceLoadError": "Could not load Jasper applications. Try reloading the page."
    }
  },
  "register": {
    "tabRegister": "Register",
    "tabImport": "Import",
    "tabResend": "Resend confirmation",
    "tab24Seven": "24SevenOffice",
    "title": "Register local user",
    "description": "Manage local users – add, edit and delete.",
    "selectUser": "Select user",
    "selectCustomer": "Select customer",
    "firstName": "First name",
    "lastName": "Last name",
    "countryCode": "Country code",
    "phoneNumber": "Mobile number",
    "phone": "Mobile number",
    "email": "Email",
    "sendMeEmail": "Send the same link to me",
    "useNewMenu": "Use new menu mapping",
    "registerUser": "Register user",
    "saveChanges": "Save changes",
    "deleteUser": "Delete user",
    "selectCustomerFirst": "Please select a customer first.",
    "registered": "Registration was successful! Please check your email to confirm the account.",
    "updated": "Update was successful! Please check your email to confirm the account.",
    "updatedNoEmail": "Update was successful!",
    "deleted": "The user has been deleted!",
    "invalidForm": "Invalid values. Complete the form and try again.",
    "emailExists": "The email already exists with another user.",
    "userExists": "User or email already exists.",
    "loadError": "Could not load users. Try reloading the page.",
    "deleteError": "Could not delete the user.",
    "confirmDeleteTitle": "Delete user",
    "confirmDelete": "Are you sure you want to delete this user?",
    "proceed": "Proceed"
  },
  "import": {
    "title": "Import users",
    "description": "Import local SSO users and mappings from a CSV file. Use the agreed file format.",
    "clickUpload": "Click to upload CSV",
    "remove": "Remove",
    "submit": "Import selected",
    "synced": "The data has been imported!",
    "serverError": "A server error occurred.",
    "mapToSso": "Map to SSO",
    "stopped": "The import was stopped – no rows were imported. Fix the rows below (row number + reason) and run the whole file again.",
    "invalidEmail": "Invalid email address.",
    "invalidPhone": "Invalid phone number.",
    "required": "Required.",
    "pickValid": "Pick a valid value from the list.",
    "fixErrors": "Fix the red fields before importing ({{count}} row(s) have errors).",
    "colRow": "Row",
    "colUser": "User",
    "colApp": "Application",
    "colError": "Error"
  },
  "resend": {
    "title": "Resend confirmation email",
    "description": "Pick the user who should get a new confirmation link by email. Search by name, email or phone.",
    "email": "Email",
    "sendMeLink": "Send the link to me too",
    "submit": "Resend email",
    "sent": "Confirmation email sent again.",
    "alreadyConfirmed": "The email is already confirmed.",
    "error": "An error occurred. The email could not be sent."
  },
  "sync24": {
    "title": "24SevenOffice",
    "description": "Sync customers from the 24SevenOffice API to the local database. Only 'Business' customers with an ID between 10000–15000 are kept.",
    "sync": "Sync customers",
    "synced": "Customers synced.",
    "failed": "Sync failed."
  },
  "users": {
    "title": "Local SSO users",
    "search": "Search",
    "searchPlaceholder": "Search name, email, phone or customer …",
    "loading": "Loading users …",
    "exportCodeword": "Export code word",
    "delete": "Delete",
    "deleteTitle": "Delete user",
    "confirmDelete": "Delete {{name}} and all mappings and data belonging to the user? This cannot be undone.",
    "deleted": "The user was deleted.",
    "deleteError": "Could not delete the user.",
    "deleteSelected": "Delete selected ({{count}})",
    "bulkDeleteTitle": "Delete users",
    "confirmBulkDelete": "Delete {{count}} users and all mappings and data belonging to them? This cannot be undone.",
    "bulkDeleted": "{{count}} users deleted.",
    "bulkDeleteError": "Could not delete the users.",
    "selectUser": "Select user",
    "selectAllUsers": "Select all visible",
    "filterEmail": "Email",
    "filterConfirmed": "Email confirmed",
    "confirmedAll": "All",
    "confirmedYes": "Confirmed",
    "confirmedNo": "Not confirmed",
    "createdAfter": "Created after",
    "customers": "Customers",
    "loginAfter": "Logged in after",
    "download": "Download CSV",
    "error": "An error occurred. Could not fetch user data.",
    "noUsers": "No users to show.",
    "count": "{{count}} users",
    "colName": "Name",
    "colEmail": "Email",
    "colPhone": "Phone",
    "colLastLogin": "Last login",
    "colCustomer": "Customer",
    "colCreated": "Created",
    "colConfirmed": "Email confirmed"
  },
  "home": {
    "title": "Dekon SSO",
    "welcome": "Welcome",
    "description": "Below are the services and features you have been given access to.",
    "noServices": "No services are registered for this user. Please ask your administrator for access.",
    "smartstoreGroup": "SmartStore & Min Butikk",
    "reportingGroup": "Reporting",
    "smartstore": "Smartstore",
    "minButikk": "Min Butikk",
    "reporting": "Reporting",
    "selectInstallationFirst": "Please select a SmartStore installation first.",
    "selectReportingFirst": "Please select a reporting instance first."
  },
  "profile": {
    "title": "My profile",
    "email": "Email",
    "dangerZone": "Danger zone",
    "deleteHint": "Deleting removes your account and all data and mappings belonging to it. This cannot be undone.",
    "deleteAccount": "Delete my account",
    "confirmDelete": "Are you absolutely sure? Your account and everything belonging to it will be permanently deleted.",
    "proceed": "Delete my account",
    "deleteError": "Could not delete the account. Please try again, or contact your administrator.",
    "adManaged": "This account is managed in Active Directory and cannot be deleted from here."
  }
}
